/**
 * House of Pertijs — Eventbrite Integratie
 * Bestand: assets/eventbrite.js
 *
 * ─────────────────────────────────────────────
 * CONFIGURATIE — pas deze twee waarden aan:
 * ─────────────────────────────────────────────
 */
const HOP_EVENTBRITE_TOKEN   = '4QSSYTCTXTHJ3RRAHFL4';
const HOP_EVENTBRITE_ORG_ID  = '2217215700553';
// ─────────────────────────────────────────────

const HopEvents = (() => {
 
  const API_BASE = 'https://www.eventbriteapi.com/v3';
 
  function formatDate(dateStr) {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleDateString('nl-NL', {
      weekday: 'long',
      day:     'numeric',
      month:   'long',
      year:    'numeric'
    });
  }
 
  function formatTime(dateStr) {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });
  }
 
  function stripHtml(html) {
    if (!html) return '';
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }
 
  // ─────────────────────────────────────────
  // OVERZICHTSPAGINA
  // ─────────────────────────────────────────
  async function loadOverview() {
    const grid  = document.getElementById('hop-events-grid');
    const empty = document.getElementById('hop-events-empty');
    const error = document.getElementById('hop-events-error');
 
    if (!grid) return;
 
    try {
      const res = await fetch(
        `${API_BASE}/organizations/${HOP_EVENTBRITE_ORG_ID}/events/` +
        `?token=${HOP_EVENTBRITE_TOKEN}` +
        `&status=live` +
        `&time_filter=current_future` +
        `&order_by=start_asc` +
        `&expand=venue,logo`,
        { method: 'GET' }
      );
 
      if (!res.ok) throw new Error(`API fout: ${res.status}`);
 
      const data = await res.json();
      const events = data.events || [];
 
      grid.innerHTML = '';
 
      if (events.length === 0) {
        grid.style.display = 'none';
        empty.style.display = 'block';
        return;
      }
 
      events.forEach(event => {
        const card = buildEventCard(event);
        grid.appendChild(card);
      });
 
    } catch (err) {
      console.error('[HopEvents] Overzicht laden mislukt:', err);
      grid.style.display = 'none';
      error.style.display = 'block';
    }
  }
 
  function buildEventCard(event) {
    const a = document.createElement('a');
    a.className = 'hop-event-card';
    a.href = `/pages/event?id=${event.id}`;
 
    const imageUrl  = event.logo?.url || event.logo?.original?.url || '';
    const venueName = event.venue?.name || '';
    const venueCity = event.venue?.address?.city || '';
    const location  = [venueName, venueCity].filter(Boolean).join(', ');
    const dateStr   = formatDate(event.start?.local);
    const timeStr   = formatTime(event.start?.local);
    const desc      = stripHtml(event.description?.text || event.summary || '');
 
    a.innerHTML = `
      <div class="hop-event-card__image-wrap">
        ${imageUrl
          ? `<img src="${imageUrl}" alt="${escHtml(event.name?.text || '')}" loading="lazy">`
          : `<div style="width:100%;height:100%;background:#e0dbd2;"></div>`
        }
      </div>
      <div class="hop-event-card__body">
        <div class="hop-event-card__meta">
          <span class="hop-event-card__date">${escHtml(dateStr)}${timeStr ? ' · ' + escHtml(timeStr) : ''}</span>
          ${location ? `<span class="hop-event-card__location">${escHtml(location)}</span>` : ''}
        </div>
        <h2 class="hop-event-card__title">${escHtml(event.name?.text || '')}</h2>
        ${desc ? `<p class="hop-event-card__desc">${escHtml(desc)}</p>` : ''}
        <span class="hop-event-card__btn">Meer informatie</span>
      </div>
    `;
 
    return a;
  }
 
  // ─────────────────────────────────────────
  // DETAILPAGINA
  // ─────────────────────────────────────────
  async function loadDetail(eventId) {
    const wrapper   = document.getElementById('hop-event-detail');
    const heroEl    = document.getElementById('hop-detail-hero');
    const mainEl    = document.getElementById('hop-detail-main');
    const sidebarEl = document.getElementById('hop-detail-sidebar');
    const errorEl   = document.getElementById('hop-detail-error');
 
    if (!wrapper) return;
 
    try {
      const [resEvent, resDesc] = await Promise.all([
        fetch(`${API_BASE}/events/${eventId}/?token=${HOP_EVENTBRITE_TOKEN}&expand=venue,logo,ticket_classes`),
        fetch(`${API_BASE}/events/${eventId}/description/?token=${HOP_EVENTBRITE_TOKEN}`)
      ]);
 
      if (!resEvent.ok) throw new Error(`API fout: ${resEvent.status}`);
 
      const event    = await resEvent.json();
      const descData = resDesc.ok ? await resDesc.json() : null;
 
      if (descData?.description) {
        event.description = { html: descData.description };
      }
 
      renderHero(heroEl, event);
      renderMain(mainEl, event);
      renderSidebar(sidebarEl, event, eventId);
 
    } catch (err) {
      console.error('[HopEvents] Detail laden mislukt:', err);
      wrapper.style.display = 'none';
      errorEl.style.display = 'block';
    }
  }
 
  function renderHero(el, event) {
    const imageUrl = event.logo?.original?.url || event.logo?.url || '';
    el.classList.remove('hop-detail-hero--skeleton');
 
    el.innerHTML = `
      ${imageUrl
        ? `<img class="hop-detail-hero__image" src="${imageUrl}" alt="${escHtml(event.name?.text || '')}">`
        : `<div class="hop-detail-hero__image" style="background:#1a3a2a;"></div>`
      }
      <div class="hop-detail-hero__overlay">
        <div class="hop-detail-hero__breadcrumb">
          <a href="/pages/events">← Alle evenementen</a>
        </div>
      </div>
    `;
  }
 
  function renderMain(el, event) {
    const dateStr  = formatDate(event.start?.local);
    const timeStr  = formatTime(event.start?.local);
    const descHtml = event.description?.html || '';
 
    el.innerHTML = `
      <div class="hop-detail-main__date">
        ${escHtml(dateStr)}${timeStr ? ' · ' + escHtml(timeStr) : ''}
      </div>
      <h1 class="hop-detail-main__title">${escHtml(event.name?.text || '')}</h1>
      <div class="hop-detail-main__description">${descHtml}</div>
    `;
  }
 
  function renderSidebar(el, event, eventId) {
    const dateStr  = formatDate(event.start?.local);
    const timeStr  = formatTime(event.start?.local);
    const endTime  = formatTime(event.end?.local);
    const venue    = event.venue;
    const tickets  = event.ticket_classes || [];
    const isFree   = tickets.every(t => t.free);
    const minPrice = tickets.length
      ? Math.min(...tickets.filter(t => !t.free).map(t => parseFloat(t.cost?.major_value || 0)))
      : null;
 
    const priceLabel = isFree
      ? 'Gratis'
      : (minPrice ? `Vanaf €${minPrice.toFixed(2).replace('.', ',')}` : 'Zie Eventbrite');
 
    const locationLines = venue ? [
      venue.name,
      venue.address?.address_1,
      [venue.address?.postal_code, venue.address?.city].filter(Boolean).join(' ')
    ].filter(Boolean) : [];
 
    el.innerHTML = `
      <div class="hop-detail-info-card">
        <div class="hop-detail-info-card__label">Datum</div>
        <div class="hop-detail-info-card__value">
          ${escHtml(dateStr)}<br>
          ${timeStr ? escHtml(timeStr) + (endTime ? ' – ' + escHtml(endTime) : '') : ''}
        </div>
 
        ${locationLines.length ? `
          <div class="hop-detail-info-card__label">Locatie</div>
          <div class="hop-detail-info-card__value">${locationLines.map(escHtml).join('<br>')}</div>
        ` : ''}
 
        <div class="hop-detail-info-card__label">Toegang</div>
        <div class="hop-detail-info-card__value">${escHtml(priceLabel)}</div>
 
        <hr class="hop-detail-info-card__divider">
 
        <!-- Eventbrite embedded checkout trigger -->
        <div id="hop-eb-widget-${escHtml(eventId)}"></div>
        <button id="hop-eb-btn-${escHtml(eventId)}" class="hop-detail-btn">
          ${isFree ? 'Gratis aanmelden' : 'Kaartjes kopen'}
        </button>
 
        <a href="/pages/events" class="hop-detail-btn hop-detail-btn--secondary">
          Alle evenementen
        </a>
      </div>
    `;
 
    // Laad Eventbrite widget script en initialiseer checkout modal
    loadEBWidget(eventId, isFree);
  }
 
  function loadEBWidget(eventId, isFree) {
    // Voorkom dubbel laden
    if (document.getElementById('hop-eb-widgets-script')) {
      initEBWidget(eventId, isFree);
      return;
    }
 
    const script = document.createElement('script');
    script.id  = 'hop-eb-widgets-script';
    script.src = 'https://www.eventbrite.com/static/widgets/eb_widgets.js';
    script.onload = () => initEBWidget(eventId, isFree);
    document.body.appendChild(script);
  }
 
  function initEBWidget(eventId, isFree) {
    if (typeof window.EBWidgets === 'undefined') {
      console.error('[HopEvents] EBWidgets niet beschikbaar');
      return;
    }
 
    window.EBWidgets.createWidget({
      widgetType:         'checkout',
      eventId:            eventId,
      modal:              true,                          // opent als modal, niet inline
      modalTriggerElementId: `hop-eb-btn-${eventId}`,   // onze eigen knop triggert de modal
      onOrderComplete: function () {
        // Optioneel: redirect na aankoop
        // window.location.href = '/pages/bedankt';
        console.log('[HopEvents] Bestelling voltooid');
      }
    });
  }
 
  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
 
  return { loadOverview, loadDetail };
 
})();
 